// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedMonthlyFinancial: null,
  errors: false,
  block: false
}

const monthlyFinancialReports = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA_MONTHLY_FINANCIAL':
      return { ...state, allData: action.data, block: false }
    case 'GET_DATA_MONTHLY_FINANCIAL':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        block: false
      }
    case 'GET_MONTHLY_FINANCIAL':
      return { ...state, selectedMonthlyFinancial: action.selectedMonthlyFinancial, block: false}
    case 'ADD_MONTHLY_FINANCIAL':
      return { ...state, errors: action.errors, block: false }
    case 'EDIT_MONTHLY_FINANCIAL':
      return { ...state, errors: action.errors, block: false }
    case 'DELETE_MONTHLY_FINANCIAL':
      return { ...state }
    case 'BLOCK':
      return { ...state, block: true }
    case 'UNBLOCK':
      return { ...state, block: false }
    default:
      return { ...state }
  }
}
export default monthlyFinancialReports
